import React, { useState, useEffect } from "react";
import { sendProductData } from "../../../apis/apis.logistics/apisProduct";
import { toast } from "react-toastify";
import { Modal } from "../../../components/ui";
import { storage } from "../../../configs/firebase";
import { v4 as uuid } from "uuid";
import { classificationOptions } from "../../../configs/Data";

const inputClass =
    "w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-60 disabled:cursor-not-allowed";
const labelClass = "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1";
const sectionClass =
    "flex items-center gap-2 text-sm font-semibold text-blue-600 dark:text-blue-400 border-b border-gray-200 dark:border-gray-600 pb-2 mb-4";
const panelClass =
    "rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50/80 dark:bg-gray-900/30 p-4 shadow-sm";

const initialState = {
    productID: 0,
    code: "",
    sku: "",
    ean: "",
    purchaseName: "",
    saleName: "",
    stockMin: "0",
    stockMax: "0",
    productBrandID: 0,
    productBrandName: "",
    path: "https://m.media-amazon.com/images/I/81ALZ7HhFDL._AC_SX342_.jpg",
    grammage: "",
    classification: "B",
    available: true,
    isDeleted: false,
    warehouseDict: [],
    productTariffList: [],
    isGroup: false,
    parentProductID: 0,
    activeType: "01",
};

// Opciones para el tipo de activo
const activeTypeOptions = [
    { value: "01", label: "PRODUCTO" },
    { value: "02", label: "REGALO" },
    { value: "03", label: "SERVICIO" },
];

export function ProductForm(props) {
    const [item, setItem] = useState(initialState);
    // const [classifications, setClassifications] = useState([]);
    useEffect(() => {
        const productFound = props.products.find(
            (item2) => item2.productID === props.itemProduct.productID
        );
        if (productFound) {
            setItem({
                productID: productFound.productID,
                code: productFound.code,
                sku: productFound.sku,
                ean: productFound.ean,
                purchaseName: productFound.purchaseName,
                saleName: productFound.saleName,
                stockMin: productFound.stockMin,
                stockMax: productFound.stockMax,
                path: productFound.path,
                grammage: productFound.grammage,
                classification: productFound.classification,
                productBrandID: productFound.productBrandID,
                productBrandName: productFound.productBrandName,
                available: productFound.available,
                isDeleted: productFound.isDeleted,
                warehouseDict: productFound.warehouseDict,
                productTariffList: productFound.productTariffList,
                isGroup: productFound.isGroup,
                parentProductID: productFound.parentProductID,
                activeType: productFound.activeType || "01",
            });
        } else {
            setItem(initialState);
        }
    }, [props.itemProduct]);

    const readImages = async (e) => {
        const file = e.target.files[0];

        const name = file.name;
        const lastDot = name.lastIndexOf(".");

        // const fileName = name.substring(0, lastDot);

        const ext = name.substring(lastDot + 1);
        const fileName =
            item.saleName
                .replaceAll(" ", "_")
                .replaceAll("-", "_")
                .toLowerCase() +
            "." +
            ext;

        console.log(fileName);
        console.log(ext);
        const id = uuid();
        // const storageRef = storage.ref("guille").child("images").child(id);
        const storageRef = storage
            .ref("guille")
            .child("images")
            .child(fileName);
        await storageRef.put(file);
        storageRef.getDownloadURL().then((url) => {
            setItem({ ...item, path: url });
        });
        //console.log(file);
    };

    function handleChange(e) {
        setItem({ ...item, [e.target.name]: e.target.value });
    }

    function handleChangeBrand(e) {
        var index = e.nativeEvent.target.selectedIndex;

        setItem({
            ...item,
            productBrandID: e.target.value,
            productBrandName: e.nativeEvent.target[index].text,
        });
    }

    function handleChangeParentProduct(e) {
        var index = e.nativeEvent.target.selectedIndex;

        setItem({
            ...item,
            parentProductID: e.target.value,
        });
    }

    function handleChangeClasification(e) {
        var index = e.nativeEvent.target.selectedIndex;

        setItem({
            ...item,
            classification: e.target.value,
        });
    }

    function handleChangeActiveType(e) {
        setItem({
            ...item,
            activeType: e.target.value,
        });
    }

    function handleToggleClick(e) {
        setItem({ ...item, [e.target.name]: e.target.checked });
    }

    const saveProduct = async (data) => {
        try {
            const response = await sendProductData(data);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const updateProducts = props.products.map((product) => {
        if (product.productID === item.productID) {
            var newItem = Object.assign({}, product);
            newItem.code = item.code;
            newItem.sku = item.sku;
            newItem.ean = item.ean;
            newItem.purchaseName = item.purchaseName;
            newItem.saleName = item.saleName;
            newItem.stockMin = item.stockMin;
            newItem.stockMax = item.stockMax;
            newItem.path = item.path;
            newItem.grammage = item.grammage;
            newItem.classification = item.classification;
            newItem.productBrandID = item.productBrandID;
            newItem.productBrandName = item.productBrandName;
            newItem.available = item.available;
            newItem.isDeleted = item.isDeleted;
            newItem.activeType = item.activeType;
            return newItem;
        } else {
            return product;
        }
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        if (item.classification != "0") {
            if (item.productBrandID != "0") {
                if (item.productID == 0) {
                    saveProduct(item).then(async (res) => {
                        item.productID = res.productID;
                        setItem(item);
                        props.setProducts((prevPlanes) => {
                            return [...prevPlanes, item];
                        });
                        toast.success("Producto registrado con exito!");
                        props.getProducts();
                    });
                } else {
                    saveProduct(item).then(async (res) => {
                        //var select = document.getElementById("productBrandID");
                        //item.productBrandName = select.options[select.selectedIndex].text;
                        //console.log("saveProduct productBrandID", item.productBrandID);
                        //console.log("saveProduct productBrandName", item.productBrandName);
                        //setItem(item);
                        toast.success("Producto actualizado con exito!");
                        props.setProducts(updateProducts);
                    });
                }
                props.onClose();
                //props.getProducts();
                props.getGroupOfProducts();
            } else {
                alert("Elija una marca. ");
            }
        } else {
            alert("Elija una clasificacion.");
        }

        //navigate("/");
    };
    const modalTitle = (
        <>
            <i className="fas fa-box text-blue-600 dark:text-blue-400" aria-hidden="true" />
            <span>{item.productID ? "Editando producto" : "Creando producto"}</span>
        </>
    );

    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.onClose}
            title={modalTitle}
            size="xl"
        >
            <input type="hidden" value={item.productID || 0} />

            <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 -mt-2">
                <div className="lg:col-span-2 space-y-6">
                    <div className={panelClass}>
                                        {/* Información Básica */}
                                        <fieldset className="mb-6">
                                            <legend className={sectionClass}>
                                                <i className="fas fa-info-circle mr-2"></i>
                                                Información Básica
                                            </legend>

                                            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                                                <div>
                                                    <div className="mb-3">
                                                        <label className={labelClass}>
                                                            Nro de orden
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={inputClass}
                                                            placeholder="Ingrese..."
                                                            name="code"
                                                            maxLength={100}
                                                            value={
                                                                item.code || ""
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="mb-3">
                                                        <label className={labelClass}>
                                                            SKU
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={inputClass}
                                                            placeholder="Ingrese..."
                                                            name="sku"
                                                            maxLength={100}
                                                            value={
                                                                item.sku || ""
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="mb-3">
                                                        <label className={labelClass}>
                                                            EAN
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={inputClass}
                                                            placeholder="Ingrese..."
                                                            name="ean"
                                                            maxLength={25}
                                                            value={
                                                                item.ean || ""
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="space-y-4">
                                                <div>
                                                    <div className="mb-3">
                                                        <label className={labelClass}>
                                                            Nombre de compra
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={inputClass}
                                                            placeholder="Ingrese..."
                                                            name="purchaseName"
                                                            maxLength={100}
                                                            value={
                                                                item.purchaseName ||
                                                                ""
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="mb-3">
                                                        <label className={labelClass}>
                                                            Nombre de venta
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={inputClass}
                                                            placeholder="Ingrese..."
                                                            name="saleName"
                                                            maxLength={100}
                                                            value={
                                                                item.saleName ||
                                                                ""
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        {/* Información de Stock */}
                                        <fieldset className="mb-6">
                                            <legend className={sectionClass}>
                                                <i className="fas fa-warehouse mr-2"></i>
                                                Información de Stock
                                            </legend>

                                            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                                                <div>
                                                    <div className="mb-3">
                                                        <label className={labelClass}>
                                                            Grammage
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={inputClass}
                                                            placeholder="Ingrese..."
                                                            name="grammage"
                                                            maxLength={100}
                                                            value={
                                                                item.grammage ||
                                                                ""
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="mb-3">
                                                        <label className={labelClass}>
                                                            Stock min almacén
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className={inputClass}
                                                            placeholder="0"
                                                            name="stockMin"
                                                            maxLength={6}
                                                            value={
                                                                item.stockMin
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="mb-3">
                                                        <label className={labelClass}>
                                                            Stock max almacén
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className={inputClass}
                                                            placeholder="0"
                                                            name="stockMax"
                                                            maxLength={6}
                                                            value={
                                                                item.stockMax
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        {/* Clasificación y Marca */}
                                        <fieldset className="mb-6">
                                            <legend className={sectionClass}>
                                                <i className="fas fa-tags mr-2"></i>
                                                Clasificación y Marca
                                            </legend>

                                            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                                                <div>
                                                    <div className="mb-3">
                                                        <label className={labelClass}>
                                                            Clasificación
                                                        </label>
                                                        <select
                                                            className={inputClass}
                                                            name="classification"
                                                            id="classification"
                                                            onChange={
                                                                handleChangeClasification
                                                            }
                                                            value={
                                                                item.classification
                                                            }
                                                        >
                                                            <option value="0">
                                                                Elige
                                                            </option>
                                                            {classificationOptions.map(
                                                                (
                                                                    item,
                                                                    index
                                                                ) => {
                                                                    return (
                                                                        <option
                                                                            key={
                                                                                index
                                                                            }
                                                                            value={
                                                                                item.id
                                                                            }
                                                                        >
                                                                            {
                                                                                item.name
                                                                            }
                                                                        </option>
                                                                    );
                                                                }
                                                            )}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="mb-3">
                                                        <label className={labelClass}>
                                                            Marca
                                                        </label>
                                                        <select
                                                            className={inputClass}
                                                            name="productBrandID"
                                                            id="productBrandID"
                                                            onChange={
                                                                handleChangeBrand
                                                            }
                                                            value={
                                                                item.productBrandID
                                                            }
                                                        >
                                                            <option value="0">
                                                                Elige
                                                            </option>
                                                            {props.brands.map(
                                                                (
                                                                    item,
                                                                    index
                                                                ) => {
                                                                    return (
                                                                        <option
                                                                            key={
                                                                                index
                                                                            }
                                                                            value={
                                                                                item.productBrandID
                                                                            }
                                                                        >
                                                                            {
                                                                                item.name
                                                                            }
                                                                        </option>
                                                                    );
                                                                }
                                                            )}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="mb-3">
                                                        <label className={labelClass}>
                                                            Tipo de Activo
                                                        </label>
                                                        <select
                                                            className={inputClass}
                                                            name="activeType"
                                                            id="activeType"
                                                            onChange={
                                                                handleChangeActiveType
                                                            }
                                                            value={
                                                                item.activeType
                                                            }
                                                        >
                                                            {activeTypeOptions.map(
                                                                (
                                                                    option,
                                                                    index
                                                                ) => {
                                                                    return (
                                                                        <option
                                                                            key={
                                                                                index
                                                                            }
                                                                            value={
                                                                                option.value
                                                                            }
                                                                        >
                                                                            {
                                                                                option.label
                                                                            }
                                                                        </option>
                                                                    );
                                                                }
                                                            )}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        {/* Imagen y Configuraciones */}
                                        <fieldset className="mb-6">
                                            <legend className={sectionClass}>
                                                <i className="fas fa-cog mr-2"></i>
                                                Configuraciones
                                            </legend>

                                            <div className="space-y-4">
                                                <div>
                                                    <div className="mb-3">
                                                        <label className={labelClass}>
                                                            Imagen del producto
                                                        </label>
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            name="path"
                                                            onChange={readImages}
                                                            className="block w-full text-sm text-gray-600 file:mr-4 file:rounded-lg file:border-0 file:bg-blue-50 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-blue-700 hover:file:bg-blue-100 dark:text-gray-300 dark:file:bg-blue-900/30 dark:file:text-blue-300"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                                <div>
                                                    <label className="flex cursor-pointer items-center gap-3">
                                                        <input
                                                            type="checkbox"
                                                            className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                                id="customSwitch3"
                                                                name="available"
                                                                checked={
                                                                    item.available
                                                                }
                                                                onChange={
                                                                    handleToggleClick
                                                                }
                                                            />
                                                        <span className={labelClass}>
                                                            <i
                                                                className={`fas fa-${
                                                                    item.available
                                                                        ? "check-circle text-green-600"
                                                                        : "times-circle text-red-600"
                                                                } mr-1`}
                                                                aria-hidden="true"
                                                            />
                                                            Disponible
                                                        </span>
                                                    </label>
                                                </div>
                                                <div>
                                                    <label className="flex cursor-pointer items-center gap-3">
                                                        <input
                                                            type="checkbox"
                                                            className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                                id="customSwitch4"
                                                                name="isGroup"
                                                                checked={
                                                                    item.isGroup
                                                                }
                                                                onChange={
                                                                    handleToggleClick
                                                                }
                                                            />
                                                        <span className={labelClass}>
                                                            <i
                                                                className={`fas fa-${
                                                                    item.isGroup
                                                                        ? "users text-green-600"
                                                                        : "user-times text-red-600"
                                                                } mr-1`}
                                                                aria-hidden="true"
                                                            />
                                                            {item.isGroup
                                                                ? "Es cabeza de grupo"
                                                                : "No es cabeza de grupo"}
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        </fieldset>

                                        {/* Grupo */}
                                        <fieldset className="mb-0">
                                            <legend className={sectionClass}>
                                                <i className="fas fa-layer-group mr-2"></i>
                                                Grupo
                                            </legend>

                                            <div>
                                                <div className="mb-3 max-w-xl">
                                                    <label className={labelClass}>
                                                        Grupo al que pertenece
                                                    </label>
                                                        <select
                                                            className={inputClass}
                                                            name="parentProductID"
                                                            id="parentProductID"
                                                            onChange={
                                                                handleChangeParentProduct
                                                            }
                                                            value={
                                                                item.parentProductID
                                                            }
                                                            disabled={
                                                                item.isGroup
                                                            }
                                                        >
                                                            <option value="0">
                                                                Elige
                                                            </option>
                                                            {props.groupOfProducts.map(
                                                                (p, index) => {
                                                                    return (
                                                                        <option
                                                                            key={
                                                                                index
                                                                            }
                                                                            value={
                                                                                p.productID
                                                                            }
                                                                        >
                                                                            {
                                                                                p.productName
                                                                            }
                                                                        </option>
                                                                    );
                                                                }
                                                            )}
                                                        </select>
                                                </div>
                                            </div>
                                        </fieldset>
                    </div>
                </div>

                <div className={`${panelClass} flex flex-col lg:col-span-1`}>
                    <h3 className={sectionClass}>
                        <i className="fas fa-image" aria-hidden="true" />
                        Vista previa
                    </h3>
                    <div className="flex flex-1 items-center justify-center rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-600 dark:bg-gray-800">
                        <img
                            className="max-h-72 w-full object-contain"
                            src={item.path}
                            alt="Vista previa del producto"
                        />
                    </div>
                    <p className="mt-3 text-xs text-gray-500 dark:text-gray-400">
                        <i className="fas fa-info-circle mr-1" aria-hidden="true" />
                        La imagen se actualizará al seleccionar un archivo.
                    </p>
                </div>
            </div>

            <div className="mt-6 flex flex-wrap justify-end gap-2 border-t border-gray-200 pt-4 dark:border-gray-700">
                <button
                    type="button"
                    onClick={props.onClose}
                    className="inline-flex items-center rounded-lg border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
                >
                    <i className="fas fa-times mr-2" aria-hidden="true" />
                    Cerrar
                </button>
                <button
                    type="button"
                    onClick={handleSubmit}
                    className="inline-flex items-center rounded-lg bg-green-600 px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-green-700"
                >
                    <i
                        className={`fas fa-${item.productID ? "save" : "plus"} mr-2`}
                        aria-hidden="true"
                    />
                    {item.productID ? "Guardar cambios" : "Registrar"}
                </button>
            </div>
        </Modal>
    );
}
